import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Video from "../components/video"

const Hobbies = () => (
  <Layout>
    <SEO title="Hobbies" />
    <h1>Hobbies</h1>
    <hr></hr>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <Video
        videoSrcURL="https://www.youtube.com/embed/YCPDVVLUw-4?rel=0&autoplay=1"
        videoTitle="Official Music Video on YouTube"
      />
  </Layout>
)

export default Hobbies
